import PropTypes from "prop-types";
import { Suspense, lazy, useCallback } from "react";
import { Tab } from "@headlessui/react";
import { Ga4WithEventParameters } from "src/helpers/google-tag-manager/events/ga4-with-eventparameters";
import DistrictReportPriceIndex from "./price-index-tab";
import Loading from "components/common/loading-spinner";

import { runIdle } from "@/src/utils/idle-utils";

import styles from "./styles.module.css";

const DistrictReportDemographicInfo = lazy(() => import("./demographic-info-tab"));

const ListingDetailDistrictReport = ({
  districtReportDemographicInfos,
  districtReportPriceInfos,
  listingTradeTypeValue,
  listingEstateType,
  listingData,
  isProjectPage,
  unitTypes,
  isPriceGraphicMarkerVisible = true,
}) => {
  const handleTabClick = useCallback((tabName) => {
    runIdle(() => {
      Ga4WithEventParameters({
        eventName: "click_widget",
        eventParameters: { widget: `bolge-raporu||${tabName}` },
      });
    }, 1000);
  }, []);

  return (
    <div className={styles.tabListWrapper}>
      <Tab.Group>
        <Tab.List className={styles.tabList}>
          {districtReportPriceInfos && (
            <Tab
              className={({ selected }) => `${styles.tab} ${selected ? styles.tabselected : styles.tabnotselected}`}
              onClick={() => handleTabClick("fiyat-endeksi")}
            >
              {isProjectPage ? "Bölgenin Fiyat Trendi" : "Fiyat Endeksi"}
            </Tab>
          )}
          {districtReportDemographicInfos && (
            <Tab
              className={({ selected }) => `${styles.tab} ${selected ? styles.tabselected : styles.tabnotselected}`}
              onClick={() => handleTabClick("demografik-bilgiler")}
            >
              Demografik Bilgiler
            </Tab>
          )}
        </Tab.List>
        <Tab.Panels className={styles.tabPanels}>
          {districtReportPriceInfos && (
            <Tab.Panel>
              <DistrictReportPriceIndex
                unitTypes={unitTypes}
                listingTradeTypeValue={listingTradeTypeValue || ""}
                listingEstateType={listingEstateType || ""}
                districtReportPriceInfos={districtReportPriceInfos}
                listingData={listingData}
                isProjectPage={isProjectPage}
                isPriceGraphicMarkerVisible={isPriceGraphicMarkerVisible}
              />
            </Tab.Panel>
          )}
          {districtReportDemographicInfos && (
            <Tab.Panel>
              <Suspense fallback={<Loading />}>
                <DistrictReportDemographicInfo districtReportDemographicInfos={districtReportDemographicInfos} />
              </Suspense>
            </Tab.Panel>
          )}
        </Tab.Panels>
      </Tab.Group>
    </div>
  );
};

ListingDetailDistrictReport.propTypes = {
  listingData: PropTypes.object,
  districtReportDemographicInfos: PropTypes.object,
  districtReportPriceInfos: PropTypes.object,
  listingTradeTypeValue: PropTypes.string,
  listingEstateType: PropTypes.string,
  isProjectPage: PropTypes.bool,
  unitTypes: PropTypes.array,
  isPriceGraphicMarkerVisible: PropTypes.bool,
};

export default ListingDetailDistrictReport;
